import React from 'react';

import { HeaderColumnPlan } from '../components/HeaderColumnPlan';
import { TitleFamilyCoverage } from '../components/TitleFamilyCoverage';
import { CheckboxForm } from '../../../../../../../../../../shared/components';

import { formattedPrice } from '../../../../../../../../../../shared/utils';
import { CoveragePlanSelected } from '../../../../../interfaces/listPlansSelected';

export interface PlansValues {
  planId: string;
  value: string;
  coverageType: string;
  codePlan: string;
}

type RowValuesCoverage = {
  description: string;
  [key: `sumaAsegurada-${number}`]: string | React.ReactNode;
  key: string | number;
};

export const groupByCodeFamily = (
  allCoveragesPerPlan: CoveragePlanSelected[]
) => {
  const groupedCoverages = allCoveragesPerPlan.reduce(
    (result: any, cobertura: CoveragePlanSelected) => {
      const key = cobertura.hasOwnProperty('codigoFamilia')
        ? `key_${cobertura['codigoFamilia']}`
        : 'key_default';

      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(cobertura);

      return result;
    },
    {}
  );

  const resultWithPlanId = groupedCoverages;

  return resultWithPlanId;
};

export const newOrderFamilies = (groupedData: any) => {
  const basicCoverages = Object.keys(groupedData).filter(
    (key: any) =>
      !groupedData[key].every(
        (cobertura: any) => cobertura.tipoCobertura === 'O'
      )
  );

  const optionalCoverages = Object.keys(groupedData).filter((key: any) =>
    groupedData[key].every((cobertura: any) => cobertura.tipoCobertura === 'O')
  );

  const newGroupFamilies: any = {};

  basicCoverages.forEach((key: any) => {
    newGroupFamilies[key] = groupedData[key];
  });

  optionalCoverages.forEach((key: any) => {
    newGroupFamilies[key] = groupedData[key];
  });

  return newGroupFamilies;
};

export function mergeArrays<T extends { codigo: string }>(arr1: T[] = [], arr2: T[] = []): T[] {
  return Object.values(
    arr1.concat(arr2).reduce(
      (acc: Record<string, T>, curr: T) => ({
        ...acc,
        [curr.codigo]: { ...(acc[curr.codigo] ?? {}), ...curr },
      }),
      {} as Record<string, T>
    )
  );
}

export const setTitleColumn = (plansId: string[]) => {
  const columnsDataTitlesSummary: any = [
    {
      title: ' ',
      width: `${100 - 20 * plansId.length}%`,
      dataIndex: 'description',
      onCell: (record: any) => {
        if (React.isValidElement(record.description)) {
          return {
            colSpan: plansId.length + 1,
          };
        }
        return {};
      },
    },
  ];
  const columnsDataTitles: any = [
    {
      title: ' ',
      width: `${100 - 20 * plansId.length}%`,
      dataIndex: 'description',
      onCell: (record: any) => {
        if (React.isValidElement(record.description)) {
          return {
            colSpan: plansId.length + 1,
          };
        }
        return {};
      },
    },
  ];
  plansId.forEach((planId) => {
    const newColumn = {
      title: <HeaderColumnPlan planId={planId} />,
      dataIndex: `sumaAsegurada-${planId}`,
      key: planId,
      width: '20%',
      onCell: (record: any) => {
        if (React.isValidElement(record.description)) {
          return {
            colSpan: 0,
          };
        }
        return {};
      },
    };
    columnsDataTitles.push(newColumn);
  });
  plansId.forEach((planId) => {
    const newColumn = {
      title: `Plan ${planId}`,
      dataIndex: `sumaAsegurada-${planId}`,
      key: planId,
      width: '20%',
      onCell: (record: any) => {
        if (React.isValidElement(record.description)) {
          return {
            colSpan: 0,
          };
        }
        return {};
      },
    };
    columnsDataTitlesSummary.push(newColumn);
  });

  return { columnsDataTitles, columnsDataTitlesSummary };
};

export const setFamilyRow = (title: any, plansAmount: any) => {
  return {
    description: <TitleFamilyCoverage titleFamily={title} />,
    colSpan: plansAmount,
    key: title,
  };
};

export const setCoverageRow = (
  description: string,
  plansValues: PlansValues[],
  stepThreeHomeQuotationFormCoverages?: any
) => {
  let row: RowValuesCoverage = {
    description,
    key: description,
  };
  plansValues.forEach((item: any) => {
    row[`sumaAsegurada-${item.planId}`] = validateValueCoverage(
      item,
      stepThreeHomeQuotationFormCoverages
    );
  });

  return row;
};

export const validateValueCoverage = (
  item: any,
  stepThreeHomeQuotationFormCoverages?: any
): React.ReactNode | string => {
  if (item.value && item.coverageType === 'O') {
    return (
      <div className='cell-with-checkbox-home'>
        <p className='cell-mount-addtional-plan-home'>
          {`$${formattedPrice(item.value)}`}
        </p>
        <CheckboxForm
          formProps={{
            label: '',
            name: `aditional-plan-${item.planId}-${item.codePlan}`,
            valuePropName: 'checked',
            style: { marginBottom: 0 },
          }}
          checkboxProps={{
            checked: false,
            value: item.value,
            onChange: (e) => {
              const isChecked = e.target.checked;
              stepThreeHomeQuotationFormCoverages.setFieldValue(
                `aditional-plan-${item.planId}-${item.codePlan}`,
                isChecked === true ? item : null
              );
            },
          }}
        />
      </div>
    );
  }
  return item.value ? `$${formattedPrice(item.value)}` : '--';
};
